var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInclusion = function SvgInclusion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.7 10.678a5 5 0 1 0 0-10 5 5 0 0 0 0 10M.174 10.044a.5.5 0 0 1 .75-.433l9 5.196a.5.5 0 0 1 0 .867l-9 5.196a.5.5 0 0 1-.75-.433zm23.658 8.92-6.129 5.142a.5.5 0 0 0-.061.705l5.142 6.128a.5.5 0 0 0 .704.062l6.129-5.143a.5.5 0 0 0 .061-.704l-5.142-6.128a.5.5 0 0 0-.704-.062"
  })));
};
export default SvgInclusion;